import Constant from '../common/Constant';
import { LATEST_MIGRATION } from '../migrations/migration';

export function getFreshUser(firebaseUser) {
  const user = {
    uid: firebaseUser.uid,
    email: firebaseUser.email,
    displayName: firebaseUser.displayName,
    settings: {
      alertIncrementMinutes: Constant.DEFAULT_ALERT_INCREMENT_MINUTES,
      alertInterval: Constant.ALERT_INTERVAL_HOURLY,
      alertDays: Constant.DEFAULT_ALERT_DAYS,
      alertStartingAt: Constant.DEFAULT_ALERT_STARTING_AT,
      alertEndingAt: Constant.DEFAULT_ALERT_ENDING_AT,
      alertEnabled: Constant.DEFAULT_ALERT_ENABLED,
      alertPausedDate: Constant.DEFAULT_ALERT_PAUSED_DATE,
      defaultCurrency: Constant.DEFAULT_CURRENCY_CODE,
    },
    activity: {
      lastActiveProjects: [],
    },
    timer: {
      status: Constant.TIMER_NOT_RUNNING,
      projectId: '',
      startAtMillis: 0,
      millisRecorded: 0,
    },
    migration: LATEST_MIGRATION,
  };

  return user;
}



// WEBPACK FOOTER //
// ./src/helpers/user.js